export enum CtaTexts {
  GET_STARTED = 'Get started',
  SEE_MENU = 'See Menu',
}
